import "core-js/modules/es.symbol";
import "core-js/modules/es.symbol.description";
import "core-js/modules/es.symbol.iterator";
import "core-js/modules/es.array.for-each";
import "core-js/modules/es.array.iterator";
import "core-js/modules/es.number.constructor";
import "core-js/modules/es.object.to-string";
import "core-js/modules/es.promise";
import "core-js/modules/es.regexp.exec";
import "core-js/modules/es.string.iterator";
import "core-js/modules/es.string.split";
import "core-js/modules/web.dom-collections.for-each";
import "core-js/modules/web.dom-collections.iterator";

var __awaiter = this && this.__awaiter || function (thisArg, _arguments, P, generator) {
  return new (P || (P = Promise))(function (resolve, reject) {
    function fulfilled(value) {
      try {
        step(generator.next(value));
      } catch (e) {
        reject(e);
      }
    }

    function rejected(value) {
      try {
        step(generator["throw"](value));
      } catch (e) {
        reject(e);
      }
    }

    function step(result) {
      result.done ? resolve(result.value) : new P(function (resolve) {
        resolve(result.value);
      }).then(fulfilled, rejected);
    }

    step((generator = generator.apply(thisArg, _arguments || [])).next());
  });
};

var __generator = this && this.__generator || function (thisArg, body) {
  var _ = {
    label: 0,
    sent: function sent() {
      if (t[0] & 1) throw t[1];
      return t[1];
    },
    trys: [],
    ops: []
  },
      f,
      y,
      t,
      g;
  return g = {
    next: verb(0),
    "throw": verb(1),
    "return": verb(2)
  }, typeof Symbol === "function" && (g[Symbol.iterator] = function () {
    return this;
  }), g;

  function verb(n) {
    return function (v) {
      return step([n, v]);
    };
  }

  function step(op) {
    if (f) throw new TypeError("Generator is already executing.");

    while (_) {
      try {
        if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
        if (y = 0, t) op = [op[0] & 2, t.value];

        switch (op[0]) {
          case 0:
          case 1:
            t = op;
            break;

          case 4:
            _.label++;
            return {
              value: op[1],
              done: false
            };

          case 5:
            _.label++;
            y = op[1];
            op = [0];
            continue;

          case 7:
            op = _.ops.pop();

            _.trys.pop();

            continue;

          default:
            if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) {
              _ = 0;
              continue;
            }

            if (op[0] === 3 && (!t || op[1] > t[0] && op[1] < t[3])) {
              _.label = op[1];
              break;
            }

            if (op[0] === 6 && _.label < t[1]) {
              _.label = t[1];
              t = op;
              break;
            }

            if (t && _.label < t[2]) {
              _.label = t[2];

              _.ops.push(op);

              break;
            }

            if (t[2]) _.ops.pop();

            _.trys.pop();

            continue;
        }

        op = body.call(thisArg, _);
      } catch (e) {
        op = [6, e];
        y = 0;
      } finally {
        f = t = 0;
      }
    }

    if (op[0] & 5) throw op[1];
    return {
      value: op[0] ? op[1] : void 0,
      done: true
    };
  }
};

import { getApp } from '@mx/util/get-app';
import { getSystem } from '@mx/util/get-system';
import { getAllCookie } from '@mx/util/get-all-cookie';
import { getAllQueryString } from '@mx/util/get-all-query-string';
import { compareVersion } from '@mx/util/compare-version';
import axios from 'axios';
import LRU from 'lru-cache';
import { warnLog, infoLog } from './log';
import { getRouterQuery, getUserInfo } from './util';
import knb from '@dp/knb';
import perf from '@mtfe/perf-h5';
var requestPromise = null;
var cache = new LRU();
var userConfig = {
  "0": {
    "reopenApplyInvoiceTip": "请仔细核对您填写的开票信息。",
    "invoiceApplyTipText": "发票预计将在48小时内开出，您可至“美团发票助手”查收。",
    "showEmail": "true",
    "showPhone": "true"
  }
};

var Env =
/** @class */
function () {
  function Env() {
    var _this = this;

    this.isOldVersionApp = false;
    this.isNewUser = false;
    this.infoItem = [];
    this.btnObj = {}; // 解析按钮信息

    this.reopen = false; // 是否从重开入口过来

    this.showEmail = true; // 展示邮件接收方式

    this.showPhone = true; // 展示手机接收方式

    this.reopenApplyInvoiceTip = '请仔细核对您填写的开票信息。'; //申请重开页面顶部提示

    this.invoiceApplyTipText = '发票预计将在48小时内开出，您可至“美团发票助手”查收。'; //开票成功页面提示话术自定义

    this.accountSystem = ''; // 账号体系区分字段（跑腿

    this.bizType = '';
    this.showAcceptType = true; //是否展示接收方式模块

    this.userTitleListLength = 0; // 当前登录用户抬头数

    this.configFromPortm = {};

    this.getCookieParams = function (key) {
      return _this.cookies[key] || '';
    };

    this.getParams = function (key) {
      return _this.queryStrings[key] || _this.cookies[key] || '';
    };

    this.getUrlParams = function (key) {
      return _this.queryStrings[key] || '';
    };

    this.init = function () {
      // 挂载 knb 到 window
      window.KNB = knb;
      perf('init', {
        project: window.devMode ? 'com.sankuai.fsp.fe.feinvoice.dev' : 'com.sankuai.fsp.fe.feinvoice',
        common: {
          dev: window.devMode
        }
      });
    };

    var _a = this,
        getParams = _a.getParams,
        getCookieParams = _a.getCookieParams;

    this.init();
    this.cookies = getAllCookie();
    this.queryStrings = getAllQueryString(); // 解析参数

    this.utmCampaign = getParams('utm_campaign');
    this.app = getApp(this.utmCampaign || ''); // todo 判断来源

    this.bizType = getRouterQuery('bizType');

    switch (this.app) {
      case 'group':
        this.token = getParams('token');
        break;
      // 点评的cookie里面的dper是httponly的

      case 'dianping-nova':
        this.token = getParams('dper');
        break;

      case 'weixin':
        this.token = getParams('token') || getParams('accesstoken');
        break;

      default:
        this.token = getParams('token') || getParams('oops');
    }

    this.appChannel = getParams('appChannel');

    if (this.appChannel) {
      infoLog("reportChannel-" + this.bizType, {
        tags: {
          appChannel: this.appChannel,
          href: window.location.href
        }
      });
    }

    this.callBackType = getParams('callBackType') || 'push';
    this.hideItem = getParams('hideItem'); // this.getInvoiceOffline = getParams('getInvoiceOffline') || '0';

    this.infoItem = getParams('infoItem') && getParams('infoItem').split(',');
    this.useInvoice = getParams('useInvoice') || '0';
    this.defaultInvoice = {
      companyTaxId: '',
      title: '',
      companyAddress: '',
      phone: '',
      bankName: '',
      bankAccount: '',
      type: 1,
      id: '',
      isDefault: true,
      defaultFlag: false
    };
    this.mainColor = getParams('mc'); // 主颜色，用于定制配色
    // KNB.getNetworkType({
    //     success: function(ret){
    //         let  networkType = ret.networkType; // '2g','3g','4g','wifi','none'(无网)，'unknown'
    //        // alert(networkType);
    //     },
    //     fail: function (e) {
    //         //alert(JSON.stringify(e));
    //     }
    // });

    getUserInfo(function (user) {
      _this.token = user.token;
      _this.uid = user.userId;
    }, function () {}); // 跑腿 60

    this.reopen = getParams('reopen') === 'true';
    this.accountSystem = getParams('accountSystem') || '';
    /* 客户端带过来的参数 */
    // 运营数据：https://wiki.sankuai.com/pages/viewpage.action?pageId=45744356

    this.utmTerm = getParams('utm_term');
    this.utmMedium = getParams('utm_medium');
    this.utmSource = getParams('utm_source');
    this.utmContent = getParams('utm_content'); // this.utmCampaign = getParams('utm_campaign');

    this.titleType = getParams('titleType') || '0'; // 环境参数

    this.lat = getParams('lat');
    this.lng = getParams('lng');
    this.stId = getParams('stid');
    this.cityId = getParams('ci');
    this.uid = getParams('userid') || getParams('userId');
    this.uuid = getParams('iuuid') || getParams('uuid');
    /*  客户端带过来的参数*/

    this.version = getParams('version_name') || this.utmTerm || this.getDianpingVersion();
    this.specialInvoice = Number(getParams('specialInvoice')) || 3; // 做一下到综扫码付的兼容，目前到综扫码传的是1 但是样式是3的样式

    if (getParams('appChannel') === 'ddzh') {
      this.specialInvoice = 3;
    } // 解析参数
    // this.app = getApp(this.utmCampaign);


    this.system = getSystem();

    if (this.system === 'ios') {
      this.system = 'iphone';
    } // 判断是否是旧版app(点评 < 9.2.0, 美团 < 7.8.0)


    if (this.app === 'group' && compareVersion(this.version, '7.8.0') === -1 || this.app === 'dianping-nova' && compareVersion(this.version, '9.2.0') === -1) {
      this.isOldVersionApp = true;
    }

    this.urlPrefix = location.protocol + "//" + location.host + "/";
    this.isShareSaved = false; // 按钮文案处理

    this.btns = getParams('btns').split(',');
    this.btns.forEach(function (item) {
      var btnInfo = item.split('-');

      if (btnInfo.length > 0) {
        btnInfo.forEach(function (btn, index) {
          _this.btnObj[btnInfo[0]] = btnInfo[1];
        });
      }
    });

    if (!this.btnObj['1']) {
      this.btnObj['1'] = '保存';
    }

    if (!this.btnObj['2']) {
      this.btnObj['2'] = '保存并使用';
    }

    this.logUserId = getParams('userid');
    this.showNotice = Boolean(+getParams('showNotice'));
    this.showTakeoutTip = Boolean(+getParams('showTakeoutTip'));
    this.lxs = getParams('lxs');
    this.getuserConfig();
  }

  Env.prototype.getDianpingVersion = function () {
    var temp = navigator.userAgent && navigator.userAgent.split('/');
    return temp[temp.length - 1];
  };

  Env.prototype.getTokenAsync = function () {
    return __awaiter(this, void 0, Promise, function () {
      var _this = this;

      return __generator(this, function (_a) {
        return [2
        /*return*/
        , new Promise(function (resolve, reject) {
          if (_this.token) {
            resolve(_this.token);
          } else {
            getUserInfo(function (user) {
              _this.token = user.token;
              _this.uid = user.userId;
              resolve(_this.token);
            }, function () {
              resolve('');
            });
          }
        })];
      });
    });
  }; //  读取用户自定义化文案配置


  Env.prototype.getuserConfig = function () {
    return __awaiter(this, void 0, void 0, function () {
      var configFromPortm, invoiceUserConfig;
      return __generator(this, function (_a) {
        switch (_a.label) {
          case 0:
            return [4
            /*yield*/
            , this.getConfig()];

          case 1:
            configFromPortm = _a.sent();
            this.configFromPortm = configFromPortm;
            invoiceUserConfig = configFromPortm[this.bizType];

            if (!invoiceUserConfig) {
              invoiceUserConfig = configFromPortm['0'];
            }

            this.reopenApplyInvoiceTip = invoiceUserConfig.reopenApplyInvoiceTip;
            this.invoiceApplyTipText = invoiceUserConfig.invoiceApplyTipText;
            this.showEmail = invoiceUserConfig.showEmail === 'true';
            this.showPhone = invoiceUserConfig.showPhone === 'true';
            this.showAcceptType = invoiceUserConfig.showAcceptType === 'true';
            return [2
            /*return*/
            ];
        }
      });
    });
  };

  Env.prototype.getConfig = function () {
    return __awaiter(this, void 0, void 0, function () {
      var prodPath, testPath, path, KEY, maxAge, _getConfig2, value, error_1, err_1;

      return __generator(this, function (_a) {
        switch (_a.label) {
          case 0:
            prodPath = 'https://s3.meituan.net/v1/mss_24c1e05b968a4937bf34e2f4ff68639e/thunders/prod/mt-invoice-result-tips/source/index.json';
            testPath = 'https://msstest.sankuai.com/v1/mss_fb8af3d1775746c9a6e5465dec16d408/thunders/test/mt-invoice-result-tips/source/index.json';
            path = window.devMode ? testPath : prodPath;
            KEY = 'invoiceUserConfig';
            maxAge = 5 * 60 * 1000;

            _getConfig2 = function _getConfig(retry) {
              if (retry === void 0) {
                retry = 1;
              }

              if (requestPromise) {
                return requestPromise;
              }

              requestPromise = axios({
                url: path,
                method: 'get'
              }).then(function (res) {
                var data = (res || {}).data;
                return data;
              }).catch(function (err) {
                requestPromise = null;

                if (retry > 0) {
                  return _getConfig2(retry - 1);
                }

                throw err;
              });
              return requestPromise;
            };

            _a.label = 1;

          case 1:
            _a.trys.push([1, 7,, 8]);

            value = cache.get(KEY);
            if (!!value) return [3
            /*break*/
            , 6];
            _a.label = 2;

          case 2:
            _a.trys.push([2, 4,, 5]);

            return [4
            /*yield*/
            , _getConfig2()];

          case 3:
            value = _a.sent();
            return [3
            /*break*/
            , 5];

          case 4:
            error_1 = _a.sent();
            value = userConfig;
            return [3
            /*break*/
            , 5];

          case 5:
            cache.set(KEY, value, maxAge);
            value = cache.get(KEY);
            _a.label = 6;

          case 6:
            return [2
            /*return*/
            , value];

          case 7:
            err_1 = _a.sent();
            warnLog('getConfigErr', {
              tag: {
                err: err_1
              }
            });
            return [3
            /*break*/
            , 8];

          case 8:
            return [2
            /*return*/
            ];
        }
      });
    });
  };

  return Env;
}();

export var env = new Env();